import { render } from "./LicencaDetalhe.vue?vue&type=template&id=77d02f15&scoped=true"
import script from "./LicencaDetalhe.vue?vue&type=script&lang=js"
export * from "./LicencaDetalhe.vue?vue&type=script&lang=js"

import "./LicencaDetalhe.vue?vue&type=style&index=0&id=77d02f15&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77d02f15"]])

export default __exports__